<template>
	<div class="d21-back" @click="back" :class="{ active: isActive }">
		<i class="material-icons">arrow_forward</i>
	</div>
</template>

<script>
	export default {
		name: "d21-back",
		computed: {
			isActive() {
				return !["query", "confirmation", "profile"].includes(this.$route.name);
			}
		},
		methods: {
			back() {
				this.$router.back();
			}
		}
	};
</script>